import React from 'react';
import Icon from './Icon';

const RailroadIcon = (props) => (
    <Icon {...props}>
        <path d="M4 4v16M20 4v16" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 6h16M4 10h16M4 14h16M4 18h16" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default RailroadIcon;